import { requestApi } from '../util/network'

// 新增跑腿订单
export const addFuwuOrder =
    (goods_id, address_id, specQuantityList, currentTime, pd_pay, password, rcb_pay, pay_message) =>
      requestApi(
        '/member_o2o_fuwu_order/add',
        'POST',
        {
          o2o_fuwu_goods_id: goods_id,
          address_id: address_id,
          spec_quantity_list: JSON.stringify(specQuantityList),
          o2o_fuwu_order_appointment_time: currentTime,
          pd_pay: pd_pay,
          password: password,
          rcb_pay: rcb_pay,
          o2o_fuwu_order_remark: pay_message
        },
        'member'
      )
// 获取支付订单
export const getFuwuOrderPay =
    (paySn) =>
      requestApi(
        '/member_o2o_fuwu_order/pay',
        'POST',
        {
          pay_sn: paySn
        },
        'member'
      )
// 获取用户订单列表
export const getFuwuOrderList =
    (parmas, state) =>
      requestApi(
        '/member_o2o_fuwu_order/get_list',
        'POST',
        {
          'page': parmas.page,
          'per_page': parmas.per_page,
          'o2o_fuwu_order_state': state
        },
        'member'
      )
// 获取订单信息
export const getFuwuOrderInfo =
    (orderId) =>
      requestApi(
        '/member_o2o_fuwu_order/get_info',
        'POST',
        {
          'o2o_fuwu_order_id': orderId
        },
        'member'
      )
// 取消订单
export const cancelFuwuOrder =
    (orderId) =>
      requestApi(
        '/member_o2o_fuwu_order/cancel',
        'POST',
        {
          'o2o_fuwu_order_id': orderId
        },
        'member'
      )
export const evaluateFuwuOrder =
    (orderId, score, comment) =>
      requestApi(
        '/member_o2o_fuwu_order/evaluate',
        'POST',
        {
          'o2o_fuwu_order_id': orderId,
          'score': score,
          'comment': comment
        },
        'member'
      )
export const receiveFuwuOrder =
    (orderId) =>
      requestApi(
        '/member_o2o_fuwu_order/receive',
        'POST',
        {
          'o2o_fuwu_order_id': orderId
        },
        'member'
      )
